/**
品牌列表
**/
<template>
	<div style="width: 1200px;
    margin: auto;">
		<!-- 面包屑导航 -->
		<el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }" class="jj">首页</el-breadcrumb-item>
			<el-breadcrumb-item
				:to="{ path: `/shopStore?storeId=${info.mid}` }">{{info.merchantName}}</el-breadcrumb-item>
			<el-breadcrumb-item>{{info.name}}</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- 置顶导航栏  开始-->
		<div :class="searchBarFixed == true ? 'pro-fixed-div' :'pro-fixed_none'" id="searchBar">
			<el-row style="width: 1200px;">
				<el-col :span="4">
					<div class="topNav_shopName" v-if="storeInfo">{{storeInfo.name}}</div>
				</el-col>
				<el-col :span="20">
					<ul class="toNav_goodsInfo">
						<li v-for="(item,index) in topNav" :key='item.id' class="toNav_goodsInfoItem"
							@click="topNavClick(item.id,index)" :class="isSelectedTab==index?'activeTab':''">
							<div>
								{{item.title}}
								<i v-if="item.id==1"> ( {{commentLength}} ) </i>
								<i v-if="item.id==2"> ( {{adviceLength}} ) </i>
							</div>
						</li>
					</ul>
				</el-col>
			</el-row>
		</div>
		<!-- 置顶导航栏  结束-->

		<el-row style="margin-bottom: 20px;">
			<el-col :span="8">
				<div class="fl">
					<!-- <div class="fl second-img" @mouseover="bigImgMove()" id="secondimg"> -->
					<div class="fl second-img" id="secondimg">
						<magnifier :qall='bigphotos' :qallBig='bigphotos' :videoUrl='videoUrl' :isVedio='isVedio'>
						</magnifier>
					</div>
					<div class="smallnav ">
						<ul class="smnav" id="smnav">
							<li @click="selectedImg(item,index)" v-for="(item,index) in moreImgArr" :key="item"
								:class="isSelectedImg==index?'active':''">
								<!-- <video v-if="item.indexOf('mp4')>0" class="videoUrlImg bg" :src="require('@/assets/img/play.png')" controls="controls"></video> -->
								<view>{{item}}</view>
								<video
									v-if="item.indexOf('mp4')>0||item.indexOf('avi')>0||item.indexOf('dat')>0||item.indexOf('3gp')>0||item.indexOf('mov')>0||item.indexOf('rmvb')>0"
									:src="`${item}`" alt="" class="bg playBg">
									<!-- <div slot="error" class="image-slot">
                            <i class="el-icon-video-play"></i>
                          </div> -->
								</video>
								<el-image :src="`${item}`" alt="" class="bg">
									<div slot="error" class="image-slot">
										<i class="el-icon-picture-outline"></i>
									</div>
								</el-image>
							</li>
						</ul>
					</div>
				</div>
			</el-col>
			<el-col :span="16">
				<div class="fr second-detail">
					<div style="margin-bottom:5px">
						<span class="virtualType" v-if="info.type==2">虚拟商品</span>
					</div>
					<p class="dettitle">{{info.name}}</p>
					<p class="tagadWord">{{ info.adWord }}</p>
					<p class="tag" v-if="info.tag!=''&&info.tag!=null">{{ info.tag }}</p>
					<div v-if="specificationlist.length>0">
						<div style="margin-bottom:20px" v-if="specificationlist[0].bxyMarketing">
							<span v-if="specificationActivityTypeId==2">限时折扣</span>
							<span v-if="specificationActivityTypeId==6">秒杀</span>
							<span v-if="specificationActivityTypeId==1">加价购</span>
							<span v-if="specificationActivityTypeId==3">满即送</span>
							<span v-if="specificationActivityTypeId==5">满减</span>
							<!-- <countDown :endTime="`${new Date(info.activityEndtime).getTime()}`" :type="'1'" endText="已经结束了"></countDown>     -->
							<flipDown
								v-if="specificationActivityTypeId&&specificationActivityTypeId!=8&&specificationActivityTypeId!=7"
								:endDate="`${new Date(specificationlist[0].bxyMarketing.activityEndtime).getTime()}`"
								:timeUnit="timeUnit" />
						</div>
					</div>
					<div class="introduce">
						<div v-if="downGoods?false:true">
							<div class=" ks clearfix">
								<div class="kuanshi fl">价格:</div>
								<div class="kuanshi-two fl kuanshi-two1" style="margin-left: 10px;">
									<span class="dettitle" v-if="userInfo.loginName == null ? true : false">¥ ?</span>
									<span class="dettitle" v-else>¥{{info.realprice!=-1?info.realprice:'面议'}} </span>
									<span class="dettitle" v-if="activityTypeNum==4">+ {{needPoints}} 积分</span>
									<!-- 降价通知 -->
								</div>
							</div>
							<!-- 地址开放 -->
							<div class=" ks clearfix" v-if="info.realprice!=-1">
								<div class="kuanshi fl">市场指导价 :</div>
								<div class="kuanshi-two fl kuanshi-two2">
									<!-- <span v-if="userInfo.loginName == null ? true : false">¥ ?</span> -->
									<span style="margin-left: 10px;" v-if="userInfo.loginName == null ? true : false">¥
										?</span>
									<span style="margin-left: 10px;"
										v-else>¥{{(info.price!=null && info.price!="")?info.marketprice: info.marketprice}}</span>
								</div>
							</div>
							<div v-if="specificationlist.length>0">
								<div v-if="specificationlist[0].bxyMarketing!=null || specificationlist[0].bxyMarketing!=null"
									class=" ks clearfix">
									<div class="kuanshi fl"
										v-if="specificationActivityTypeId==2||specificationActivityTypeId==6 ||specificationActivityTypeId==4||specificationActivityTypeId==1||specificationActivityTypeId==3||specificationActivityTypeId==5">
										促销 :</div>
									<div class="kuanshi-two fl kuanshi-two1"
										v-if="specificationActivityTypeId==2||specificationActivityTypeId==6 ||specificationActivityTypeId==4||specificationActivityTypeId==1||specificationActivityTypeId==3||specificationActivityTypeId==5">
										<span class="zhekouCss" v-if="specificationActivityTypeId==2">限时折扣</span>
										<span class="zhekouCss" v-if="specificationActivityTypeId==4">积分兑换</span>
										<span class="zhekouCss" v-if="specificationActivityTypeId==6">秒杀</span>
										<span class="zhekouCss" v-if="specificationActivityTypeId==1">加价购</span>
										<span class="zhekouCss" v-if="specificationActivityTypeId==3">满即送</span>
										<span class="zhekouCss" v-if="specificationActivityTypeId==5">满减</span>
										<span>截止时间：{{specificationlist[0].bxyMarketing.activityEndtime}}</span>
										<div style="font-size: 12px;margin: 10px 0;color: #ff6700;"
											v-if="specificationActivityTypeId==5 && info.bxyActivityRuleList.length>0">
											<div v-for="(item2, index2) in info.bxyActivityRuleList" :key="index2">
												<text class="tag" :class="{ tag2: index2 > 0 }">满减</text>
												单笔订单满{{ item2.total }}元，立减{{ item2.maxNum }}元
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 地址后期开放 -->
							<!-- <div class=" ks clearfix">
                        <div class="kuanshi fl">配送 :</div>
                    <div class="kuanshi-two fl kuanshi-two1" >
                            <el-cascader
                                v-model="cascaderAreaValue"
                                ref="cascaderAddr"
                                class="cascaderArea"
                                placeholder="发货地址"
                                :props="{ checkStrictly: true }"
                                :options="getprovince"
                                @change="areaHandleChange">
                            </el-cascader>
                            至
                            <el-cascader
                                v-model="shippingAreaValue"
                                ref="cascaderAddr"
                                class="cascaderArea"
                                placeholder="收货地址"
                                :props="{ checkStrictly: true }"
                                :options="getprovince"
                                @change="areaHandleChange">
                            </el-cascader>
                            <div style="margin: 10px 0px 20px 0;">有货,下单后立即发送</div>
                    </div>
                  </div>
                            <div class=" ks clearfix">
                    <div class="kuanshi fl">服务 :</div>
                    <div class="kuanshi-two fl kuanshi-two1" >
                                    由 <a href="javascript:;"> 本网站 </a> 发货并提供售后服务 [ 快递：¥{{info.postage||0.00}} ]
                    </div>
                  </div>
                            <div class=" ks clearfix">
                    <div class="kuanshi fl">红包 :</div>
                    <div class="kuanshi-two fl kuanshi-two1" >
                                    可用0个
                    </div>
                  </div> -->
							<!-- <div class=" ks clearfix">
                    <div class="kuanshi fl">款式 :</div>
                    <div class="kuanshi-two fl kuanshi-two1" >
                                    <el-radio-group v-model="sizeForm.type" size="medium">
                                        <el-radio border label="小剧场"></el-radio>
                                        <el-radio border label="音波款"></el-radio>
                                    </el-radio-group>
                    </div>
                    <span class="select_k" id="select_k"><i></i>&nbsp;请输入选择款式</span>
                  </div> -->
							<!-- <div class=" ks clearfix">
                    <div class="kuanshi fl">规格 :</div>
                    <div class="kuanshi-two fl kuanshi-two2">
                                    <el-radio-group v-model="goodsSize" size="medium" >
                                        <el-radio border :label="item.bXySid" @change="getgoodsSize(item.realprice,item.bXySid)" v-for="(item,index) in info.specificationlist" :key="index">{{item.name}}</el-radio>
                                  </el-radio-group>
                    </div>
                    <span class="select_c" id="select_c"><i></i>&nbsp;请输入选择材质</span>
                  </div> -->
							<!-- 商品规格 -->
							<!-- <div class=" ks clearfix" v-for="(item1,index) in attributelist" :key="index">
                    <div class="kuanshi fl">{{item1.bxyname}} :</div>
                    <div class="kuanshi-two fl kuanshi-two2">
                                    <el-radio-group v-model="goodsSize" size="medium" >
                                        <el-radio border :label="item2.id" @change="getgoodsSize('',item2.bxysid)" v-for="(item2,index) in item1.bXyAttributeList" :key="index">{{item2.name}}</el-radio>
                                  </el-radio-group>
                    </div>
                    <span class="select_c" id="select_c"><i></i>&nbsp;请输入选择材质</span>
                  </div> -->
							<div class=" ks clearfix cc" v-for="(item1,index) in attributelist" :key="index">
								<goodsSizeItem :attributelist="item1" :goodsIdArr='goodsIdArr'
									:getgoodsSize='getgoodsSize'></goodsSizeItem>
							</div>
							<div style="margin: 15px 50px;"
								v-if="specificationActivityTypeId==5||specificationActivityTypeId==1||specificationActivityTypeId==3">
								<span style="color:#D33A31">注意：该活动仅限于加入购物车</span>
							</div>
							<div class=" ks clearfix">
								<!-- <div class="kuanshi fl">数量{{activityTypeNum==4||activityTypeNum == 8?1:(specifiStock?Number(specifiStock):(info.bxySeckillRule?Number(info.bxySeckillRule.commodityNum):Number(specifiStock)))}} :</div> -->
								<div class="kuanshi fl">数量：</div>
								<div class="number fl">{{info.numbe}}
									<el-input-number v-if="activityTypeNum!=6" v-model="info.number"
										@change="handleChange" :min="1" :max="Number(lastStock)"
										label="描述文字"></el-input-number>
									<el-input-number v-if="activityTypeNum==6" v-model="info.number"
										@change="handleChange" :min="1"
										:max="(info.bxySeckillRule?Number(info.bxySeckillRule.commodityNum):Number(specifiStock))"
										label="描述文字"></el-input-number>
									<p style="color:#d33a31;margin-top:5px">剩余库存{{lastStock}}件</p>
								</div>
							</div>
						</div>
						<div class="buygoods purchaseRow" v-if="info.status!=2&&specifiStock>0&&info.realprice!=-1">
							<a href="javascript:;" class="rightnow2 fl" id="rightnow2" v-if="activityTypeNum!=4"
								@click="orderNow(info.status,info.approvalStatus)">立即购买</a>
							<a href="javascript:;" class="rightnow2 fl" id="rightnow2"
								v-if="info.type!=2 && activityTypeNum==4"
								@click="orderNow(info.status,info.approvalStatus)">立即兑换</a>
							<a v-if="info.type!=2 && activityTypeNum!=4" href="javascript:;" style="color:white"
								class="addcar2 fl" id="addcar2"
								@click="onAddCar(info.id,info.number,info.bXySid,info.status,info.approvalStatus)">
								<i class="addshopcar"></i>加入购物车</a>
						</div>
						<div class="buygoods comtactUs" v-if="info.realprice==-1">
							<el-button type="warning" @click="comtactUs" size="small"
								icon="el-icon-s-comment">联系我们</el-button>
						</div>
						<!-- <div class="buygoods serviceBn site-demo-layim">
							<el-button type="primary" plain @click="getCallCenter()" size="small"
								icon="el-icon-headset">联系客服</el-button>
						</div> -->
						<div class="buygoods serviceBn site-demo-layim">
							<el-button type="primary" plain @click="ToChat()" size="small"
								icon="el-icon-headset">联系客服</el-button>
						</div>
						<el-dialog :title="kfname + '为您服务...'" center :visible.sync="dialogVisible" width="40%"
							:close-on-click-modal="false">
							<div class="dialogContent">
								<div class="chat-box" v-loading="loadingdialog">
									<div id="message-list">
										<div v-for="(message, index) in messages" :key="index">
											<div v-if="message.messageType == 0"
												:class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
												<div class="divzt">{{message.readState == 'true' ? '已读' : '未读'}}</div>
												<div class="divimg"><img :src="message.avatar" alt="" /></div>
												<div class="divtext" v-html="textfaceimg(message.content)"></div>
											</div>
											<div v-else-if="message.messageType == 3"
												:class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
												<div class="divzt">{{message.readState == 'true' ? '已读' : '未读'}}</div>
												<div class="divimg"><img :src="message.avatar" alt="" /></div>
												<div class="divtext">
													<!-- 商品卡片 -->
													<div class="minicard">
														<div class="left"><img :src="JSON.parse(message.extend).image" alt="" />
														</div>
														<div class="right">
															<span>名称：<strong>{{JSON.parse(message.extend).goodsname}}</strong></span>
															<span>价格：<strong
																	style="color:#D33A31;">{{JSON.parse(message.extend).price}}</strong></span>
														</div>
													</div>
												</div>
											</div>
											<!-- 图片 -->
											<div v-else-if="message.messageType == 1"
												:class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
												<div class="divzt">{{message.readState == 'true' ? '已读' : '未读'}}</div>
												<div class="divimg"><img :src="message.avatar" alt="" /></div>
												<div class="divtext" style="cursor: pointer;" @click="imglook(message.extend.url)">
													<img style="width:100px; height:100px;" :src="message.extend.url"
														alt="" srcset="" />
												</div>
											</div>
											<!-- 视频 -->
											<div v-else-if="message.messageType == 5"
												:class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
												<div class="divzt">{{message.readState == 'true' ? '已读' : '未读'}}</div>
												<div class="divimg"><img :src="message.avatar" alt="" /></div>
												<div class="divtext">
													<video controls style="width: 200px; height: 250px;">
														<source :src="message.extend.src" type="video/mp4">
													</video>
												</div>
											</div>
											<!-- 表情 -->
											<div v-else
												:class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
												<div class="divzt">{{message.readState == 'true' ? '已读' : '未读'}}</div>
												<div class="divimg"><img :src="message.avatar" alt="" /></div>
												<div class="divtext">
													<img :src="giffn(message.content)" alt="" />
												</div>
											</div>
										</div>

									</div>
									<div class="input-box">
										<transition name="el-zoom-in-bottom">
											<div class="imgbox" v-show="isdisplay">
												<img @click="isdisplay = !isdisplay,clickimg(item.img)"
													v-for="(item, index) in gifarr" :key="item.id"
													:src="require(`../../../static/layui/images/face/` + item.img)"
													alt="" />
											</div>
										</transition>
										<div class="textimgdiv">
											<div @click="isdisplay = !isdisplay"><img
													src="../../assets/images/pc/xiaolian.png" alt="" /></div>
											<input @change="handleFileChange" style="display: none;" type="file"
												name="file" ref="files" />
											<div @click="shangchuanimgfn"><img src="../../assets/images/pc/tupian.png"
													alt="" /></div>
											<input @change="handleFileMP4Change" style="display: none;" type="file"
												name="file" ref="mp4files" />
											<div @click="shangchuanmp4fn"><img style="height: 28px; width: 30px;"
													src="../../assets/images/pc/shipin.png" alt="" /></div>
										</div>
										<div class="minicard" v-if="isshowminicard">
											<div class="left"><img :src="goodspart.image" alt="" /></div>
											<div class="right">
												<span>名称：<strong>{{goodspart.goodsname}}</strong></span>
												<span>价格：<strong
														style="color:#D33A31;">{{goodspart.price}}</strong></span>
												<div class="dianjifs" @click="onegoodschat">点击发送</div>
											</div>
										</div>
										<input type="text" v-model="messageText"
											@keydown.enter="addMessage(0,messageText)" placeholder="请输入消息内容">
										<button @click="addMessage(0,messageText)">发送</button>
									</div>
								</div>
							</div>
						</el-dialog>

						<div class="buygoods" v-if="specifiStock==0">
							<a href="javascript:;" class="rightnow2 fl"
								style="color:#a0a0a0;background: #e4e4e4;border: none; cursor: not-allowed;"
								id="rightnow2">{{downGoods?'商品已下架':'暂时缺货'}}</a>
						</div>
						<div class="buygoods" v-if="info.status==2">
							<a href="javascript:;" class="rightnow2 fl"
								style="color:#a0a0a0;background: #e4e4e4;border: none; cursor: not-allowed;"
								id="rightnow2">商品已下架</a>
						</div>
					</div>

				</div>
			</el-col>
		</el-row>
		<el-row class="twoButtom" data-id="123">
			<el-button @click="addCollectionHandle(info.id)" v-if="info.isCollect==0?true:false" size="mini"
				icon="el-icon-star-off">收藏</el-button>
			<el-button @click="removeCollectionHandle(info.id)" v-if="info.isCollect==1?true:false" size="mini"
				icon="el-icon-star-on">已收藏</el-button>
		</el-row>
		<el-row>
			<el-col :span="4" v-if="lefthotGoodsList">
				<shopStoreItem :shopInfo='storeInfo' :storeScore='storeScore' :isshow="1" :supplieStore='0'>
				</shopStoreItem>
				<hotGoods :navTitle="hotGoodsTitle" :hotGoodsList='lefthotGoodsList' :supplieStore='0'></hotGoods>
			</el-col>
			<el-col :span="20">
				<el-tabs v-model="activeName" @tab-click="tabhandleClick" class="goodsTabsr_card" type="border-card">
					<el-tab-pane name='0'>
						<span slot="label" class="goodsTabs">商品详情</span>
						<div class="goods_advisory goodsDetails">
							<div v-html="info.description"></div>
						</div>
					</el-tab-pane>
					<el-tab-pane name='1'>
						<span slot="label" class="goodsTabs"> 商品评价 <i> ( {{commentLength}} ) </i></span>
						<el-row :gutter="20" class="goodsCommentList" v-for="item in goodsCommentList"
							:key="item.bXyDoeid">
							<el-col :span="5">
								<el-avatar :size="60" src="https://empty" @error="errorHandler">
									<img :src="item.profile_photo" />
								</el-avatar>
								<span>{{item.isAnonymous!=1?item.nickname:encryption(item.nickname,2)}}</span>
								<!-- <span>{{encryption(item.nickname,2)}}</span> -->
							</el-col>
							<el-col :span="19">
								<p><el-rate disabled v-model="item.matchScore" show-text></el-rate></p>
								<p class="goodsCommentList_content">{{item.content}}</p>
								<div v-if="item.images.length>0">
									<el-image class="commentListImg" v-for="(imgItem,index) in item.images"
										:src="imgItem" :key="index" :preview-src-list="[imgItem]">
										<div slot="error" class="image-slot">
											<i class="el-icon-picture-outline"></i>
										</div>
									</el-image>
								</div>
								<div class="lastLine">
									<div class="goodsCommentList_goodsName">
										<p class="goodsNameText OneLineDisplay" :title="item.goodsName">
											{{item.goodsName}}
										</p>
										<!-- <span> {{item.bxmId}}</span> 商品属性 -->
										<span style="margin-left:20px"> {{item.createTime}}</span>
									</div>
									<div class="goodsCommentList_opreate">
										<!-- 点赞，后续增加 -->
										<!-- <span><img :src="require('@/assets/img/noLIke.png')" alt="" @click="likeHadle(item.bXyDoeid,item.likepoint)">( {{item.likepoint||0}} )</span> -->
										<!-- <i @click="openReplayHadle(item.id)" class="el-icon-chat-dot-round"></i> -->
										<i @click="item.showRepalyBox=!item.showRepalyBox"
											class="el-icon-chat-dot-round"></i>
									</div>
								</div>
								<div class="repalyBox" v-show="item.showRepalyBox">
									<el-input placeholder="回复楼主" v-model="replayContent" class="goods_advisory_input_1">
										<el-button slot="append" class="advisory_button"
											@click="replayHandle(item.bXyDoeid)">回复</el-button>
									</el-input>
								</div>
								<!-- 某条评论下的回复 -->
								<div v-if="item.replyList.length>0?true:false">
									<div class="replayBox" v-for="(replayItem,index) in item.replyList" :key='index'>
										<el-divider></el-divider>
										<span
											:class="replayItem.type==1?'redColor':''">{{replayItem.type==1?replayItem.nickname:encryption(replayItem.nickname,2)}}
											回复：</span>
										<p style="margin:10px 0" :class="replayItem.type==1?'redColor':''">
											{{replayItem.content}}
										</p>
										<div class="lastLine">
											<div class="goodsCommentList_goodsName">
												<div> {{item.createTime}}</div>
											</div>
										</div>
									</div>
								</div>
							</el-col>
						</el-row>
						<div class="goods_advisory" v-if="goodsCommentList.length==0?true:false">
							暂无评价
						</div>
					</el-tab-pane>
					<el-tab-pane name='2'>
						<span slot="label" class="goodsTabs"> 商品咨询 <i>( {{adviceLength}} )</i></span>
						<div class="goods_advisory">
							<input placeholder="请输入内容" v-model="inputContent" class="goods_advisory_input" />
							<el-button slot="append" class="advisory_button" @click="advisoryHandle()">提问</el-button>
						</div>
						<div class="goods_adviceList">
							<el-row v-for="item in goodsAdviceList" :key="item.bXyDaid"
								style="margin-bottom: 20px;padding: 15px;border-bottom: 1px solid #dcdfe6;">
								<el-col :span="12">
									<span class="textRight askText">问</span>
									<span class="textRight">{{item.content}}</span>
									<!-- <span class="textRight">点赞（{{ 11 }}）</span> -->
								</el-col>
								<el-col :span="12" class="goods_adviceList_right">
									<span class="textRight">{{item.name}}</span>
									<span class="textRight">{{item.createTime}}</span>
								</el-col>
								<el-col :span="24" style="margin-top: 10px;"
									v-if="item.bxyDealAdvisoryReplyList.length>0?true:false">
									<el-row v-for="item1 in item.bxyDealAdvisoryReplyList" :key="item1.bXyDarid">
										<el-col :span="12">
											<span class="textRight askText">答</span>
											<span class="textRight">{{item1.content}}</span>
											<!-- <span class="textRight">点赞（{{ 11 }}）</span> -->
										</el-col>
										<el-col :span="12" class="goods_adviceList_right">
											<span class="textRight">{{item1.createBy}}</span>
											<span class="textRight">{{item1.createTime}}</span>
										</el-col>
									</el-row>
								</el-col>
								<el-col :span="24" style="margin-top: 10px;"
									v-if="item.bxyDealAdvisoryReplyList.length==0?true:false">
									<span class="textRight askText replayText">答</span>
									<span>暂无回答</span>
								</el-col>
							</el-row>
						</div>
					</el-tab-pane>
					<el-tab-pane name='3'>
						<span slot="label" class="goodsTabs"> 商家介绍</span>
						<!-- 商家介绍 -->
						<span v-if="storeInfo">{{storeInfo.companyProfile}}</span>
					</el-tab-pane>
					<el-tab-pane name='4'>
						<span slot="label" class="goodsTabs"> 服务保障</span>
						<!-- 服务保障 -->
						<div v-if="serviceList.length>0" class="serviceGuarantee ">
							<el-row v-for="item in serviceList" :key="item.id">
								<el-col :span="2">
									<el-image class="bigImgSizeCss" :src="item.icon">
										<div slot="error" class="image-slot">
											<i class="el-icon-picture-outline"></i>
										</div>
									</el-image>
								</el-col>
								<el-col :span="20" class="serveTitlebox">
									<p class="serveTitle">{{item.describe}}</p>
									<p class="decorDetail">{{item.remark}}</p>
								</el-col>
							</el-row>
						</div>
						<div style="text-align:center;" v-else>暂无相关数据</div>
					</el-tab-pane>
				</el-tabs>
			</el-col>
		</el-row>

		<!-- 提问弹框 -->
		<el-dialog class="addCartBox" :visible.sync="centerDialogVisible" width="30%" center>
			<div style="text-align: center" v-show="successInfo">
				<div class="addGoodsInfo">提问成功</div>
				<span slot="footer" class="dialog-footer">
					<!-- <el-button @click="centerDialogVisible = false">继续购物</el-button> -->
					<el-button type="primary" @click="centerDialogVisible = false">继续浏览</el-button>
				</span>
			</div>
			<div style="text-align: center" v-show="!successInfo">
				<div>需要登录</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="centerDialogVisible = false">确定</el-button>
				</span>
			</div>
		</el-dialog>

		<!-- 联系我们 -->
		<el-dialog class="addCartBox" :visible.sync="comtactVisible" width="30%" title="联系我们" @close='beforeClose'
			center>
			<div>
				<el-form :model="comtactruleForm" status-icon :rules="rules" ref="comtactruleForm" label-width="100px"
					class="demo-ruleForm">
					<el-form-item label="姓名" prop="comtactName">
						<el-input type="text" v-model="comtactruleForm.comtactName" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" prop="comtactPhone">
						<el-input type="text" v-model="comtactruleForm.comtactPhone" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="留言" prop="comtactRemark">
						<el-input type="textarea" v-model="comtactruleForm.comtactRemark"></el-input>
					</el-form-item>
					<el-form-item style="text-align:end">
						<el-button type="primary" size="small" @click="submitForm('comtactruleForm')">提交</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<!-- 加入购物车弹框 -->
		<el-dialog class="addCartBox" :visible.sync="addDialogVisible" width="30%" center>
			<div style="text-align: center" v-show="successInfo">
				<div class="addGoodsInfo">已成功加入购物车！</div>
				<!-- <div>{{ addGoodsName }}</div> -->
				<span slot="footer" class="dialog-footer">
					<el-button @click="addDialogVisible = false">继续购物</el-button>
					<el-button type="primary" @click="$router.push('/shoppingcart')">去购物车结算</el-button>
				</span>
			</div>
			<div style="text-align: center" v-show="!successInfo">
				<div>需要登录</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="addDialogVisible = false">确定</el-button>
				</span>
			</div>
		</el-dialog>
		<!-- 加入购物车结束 -->

		<!-- 回复 开始 -->
		<el-dialog class="addCartBox" :visible.sync="addReplayVisible" width="30%" center>
			<div style="text-align: center" v-show="relaysuccessInfo">
				<div class="addGoodsInfo">评论成功,等待客服进行处理!</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="addReplayVisible = false">确定</el-button>
				</span>
			</div>
			<div style="text-align: center" v-show="!relaysuccessInfo">
				<div>需要登录</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="addReplayVisible = false">确定</el-button>
				</span>
			</div>
		</el-dialog>
		<!-- 回复 结束 -->
	</div>
</template>
<script>
	import axios from 'axios';
	import magnifier from '@/components/magnifier' // 放大镜
	import hotGoods from '@/components/hotGoods'
	import shopStoreItem from '@/components/shopStoreItem'
	import goodsSizeItem from '@/components/goodsSize' // 商品规格
	import countDown from '@/components/countDown' // 倒计时
	// import addressSelect from '@/components/addressSelect'
	import '@/assets/css/goodsDetail/goodsDetail.css'
	import {
		baseUrl
	} from '@/api/axiosFun';
	import {
		userFeedback,
		serviceGuarantee,
		shoppingCartlist,
		commoditylist,
		commodityDetails,
		getAttributelist,
		getSpecificationDetail,
		addShoppingCart,
		area_list,
		storerList,
		removeCollection,
		addCollection,
		goodsAdvice,
		addgoodsAdvice,
		commentList,
		replayComment,
		score,
		imFriends,
		imUserID,
		getAfterSaleschatpoople,
		getoldmessage
	} from "@/api/xunyou";
	import Vue from 'vue';
	import $, {
		parseJSON
	} from 'jquery'
	import {
		mapState,
		mapMutations
	} from 'vuex'
	import flipDown from 'vue-flip-down';
	import {
		login
	} from '../../api/userMG'
	import url from 'postcss-url';
	// import
	export default {
		data() {
			return {
				gifarr: [{
						"img": "0.gif",
						"id": 0
					},
					{
						"img": "1.gif",
						"id": 1
					},
					{
						"img": "2.gif",
						"id": 2
					},
					{
						"img": "3.gif",
						"id": 3
					},
					{
						"img": "4.gif",
						"id": 4
					},
					{
						"img": "5.gif",
						"id": 5
					},
					{
						"img": "6.gif",
						"id": 6
					},
					{
						"img": "7.gif",
						"id": 7
					},
					{
						"img": "8.gif",
						"id": 8
					},
					{
						"img": "9.gif",
						"id": 9
					},
					{
						"img": "10.gif",
						"id": 10
					},
					{
						"img": "11.gif",
						"id": 11
					},
					{
						"img": "12.gif",
						"id": 12
					},
					{
						"img": "13.gif",
						"id": 13
					},
					{
						"img": "14.gif",
						"id": 14
					},
					{
						"img": "15.gif",
						"id": 15
					},
					{
						"img": "16.gif",
						"id": 16
					},
					{
						"img": "17.gif",
						"id": 17
					},
					{
						"img": "18.gif",
						"id": 18
					},
					{
						"img": "19.gif",
						"id": 19
					},
					{
						"img": "21.gif",
						"id": 20
					},
					{
						"img": "22.gif",
						"id": 21
					},
					{
						"img": "23.gif",
						"id": 23
					},
					{
						"img": "24.gif",
						"id": 24
					},
					{
						"img": "25.gif",
						"id": 25
					},
					{
						"img": "26.gif",
						"id": 26
					},
					{
						"img": "27.gif",
						"id": 27
					},
					{
						"img": "28.gif",
						"id": 28
					},
					{
						"img": "29.gif",
						"id": 29
					},
					{
						"img": "30.gif",
						"id": 30
					},
					{
						"img": "31.gif",
						"id": 31
					},
					{
						"img": "32.gif",
						"id": 32
					},
					{
						"img": "33.gif",
						"id": 33
					},
					{
						"img": "34.gif",
						"id": 34
					},
					{
						"img": "35.gif",
						"id": 35
					},
					{
						"img": "36.gif",
						"id": 36
					},
					{
						"img": "37.gif",
						"id": 37
					},
					{
						"img": "38.gif",
						"id": 38
					},
					{
						"img": "39.gif",
						"id": 39
					},
					{
						"img": "40.gif",
						"id": 40
					},
				],
				loadingdialog: false, // loading效果
				isshowminicard: true, // 小卡片的显示隐藏
				userid: null,
				id: localStorage.getItem('userdata'),
				socket: null,
				from: {}, // 收发人信息
				goodspart: {}, // 点击咨询时的小卡片信息
				isdisplay: false, // 是否显示发送表情模块
				messageText: '', // 聊天框内容
				messages: [], // 聊天所有数据
				dialogVisible: false,
				activityTypeNum: '',
				specificationActivityTypeId: '', //根据属性绑定活动类型
				needPoints: 0,
				videoType: 'mp4 avi dat 3gp mov rmvb',
				timeUnit: ['天', '时', '分', '秒'],
				isSelectedImg: '',
				selected: false,
				selectedImgUrl: '', // 选择的图片路径
				isVedio: true, // 是否是视频
				bigphotos: '',
				videoUrl: '',
				moreImgArr: [],
				userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
				addDialogVisible: false, //加入购物车弹框
				goodsSize: '',
				info: {},
				centerDialogVisible: false,
				successInfo: true,
				inputContent: '',
				hotGoodsTitle: '热卖商品',
				storeInfo: {
					name: ''
				},
				storeScore: {},
				lefthotGoodsList: [],
				attributelist: [],
				specificationlist: [],
				goodsIdArr: [], // 选中的属性对象数组
				idArr: [], // 选中的属性id集合
				selectAttrId: '',
				num1: 1, //商品数量
				//  getprovince:[], // 地址联动
				cascaderAreaValue: [], // 发货地址
				//  shippingAreaValue:[], // 收货地址
				shippingAreaValue: [], // 收货地址
				goodsAdviceList: [], // 商品咨询
				adviceLength: 0,
				commentLength: 0,
				//  顶部导航栏
				isTabActive: '0',
				isSelectedTab: 0,
				activeName: '0',
				searchBarFixed: false,
				stock: '',
				topNav: [{
						id: 0,
						title: '商品详情',
						num: '',
					},
					{
						id: 1,
						title: '商品评价',
						num: '',
					},
					{
						id: 2,
						title: '商品咨询',
						num: '',
					},
					{
						id: 3,
						title: '商家介绍',
						num: '',
					},
					{
						id: 4,
						title: '服务保障',
						num: '',
					}
				],
				//  商品评价
				// emojiMap: {
				// 	"微笑": "<img src='../../../static/layui/images/face/0.gif'/>",
				// 	"嘻嘻": "<img src='../../../static/layui/images/face/1.gif'/>",
				// 	"哈哈": "<img src='../../../static/layui/images/face/2.gif'/>",
				// 	"可爱": "<img src='../../../static/layui/images/face/3.gif'/>",
				// 	"可怜": "<img src='../../../static/layui/images/face/4.gif'/>",
				// 	"挖鼻": "<img src='../../../static/layui/images/face/5.gif'/>",
				// 	"吃惊": "<img src='../../../static/layui/images/face/6.gif'/>",
				// 	"害羞": "<img src='../../../static/layui/images/face/7.gif'/>",
				// 	"挤眼": "<img src='../../../static/layui/images/face/8.gif'/>",
				// 	"闭嘴": "<img src='../../../static/layui/images/face/9.gif'/>",
				// 	"鄙视": "<img src='../../../static/layui/images/face/10.gif'/>",
				// 	"爱你": "<img src='../../../static/layui/images/face/11.gif'/>",
				// 	"泪": "<img src='../../../static/layui/images/face/12.gif'/>",
				// 	"偷笑": "<img src='../../../static/layui/images/face/13.gif'/>",
				// 	"亲亲": "<img src='../../../static/layui/images/face/14.gif'/>",
				// 	"生病": "<img src='../../../static/layui/images/face/15.gif'/>",
				// 	"太开心": "<img src='../../../static/layui/images/face/16.gif'/>",
				// 	"白眼": "<img src='../../../static/layui/images/face/17.gif'/>",
				// 	"右哼哼": "<img src='../../../static/layui/images/face/18.gif'/>",
				// 	"左哼哼": "<img src='../../../static/layui/images/face/19.gif'/>",
				// 	"嘘": "<img src='../../../static/layui/images/face/20.gif'/>",
				// 	"衰": "<img src='../../../static/layui/images/face/21.gif'/>",
				// 	"委屈": "<img src='../../../static/layui/images/face/22.gif'/>",
				// 	"吐": "<img src='../../../static/layui/images/face/23.gif'/>",
				// 	"哈欠": "<img src='../../../static/layui/images/face/24.gif'/>",
				// },
				emojiMap: {
					"微笑": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/ebb0d566983e98b207de65928466724c.gif'/>",
					"嘻嘻": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/cfd6c724034619e463343bdd18ae2054.gif'/>",
					"哈哈": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/398e9cfe007561f3d843403eb5223fc3.gif'/>",
					"可爱": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/326dfc753bdabab5a1078d72aad8a831.gif'/>",
					"可怜": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/d0c3837063bbbfe04e1d61db168b5fa8.gif'/>",
					"挖鼻": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/6c71b664cd42b83830cf33ed75587cbf.gif'/>",
					"吃惊": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/4c1f8f268a7d5e34822cd91c261e9b33.gif'/>",
					"害羞": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/2f447e6e2e3b40449e878bc864e2b6b0.gif'/>",
					"挤眼": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/b21becfa700641dba951c13ade328b08.gif'/>",
					"闭嘴": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/4909784c09bb0d34af9ec6bee01366c3.gif'/>",
					"鄙视": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/05697b2d1b83b15dfcee51a138a29a9d.gif'/>",
					"爱你": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/47a9dd92fa80420b2ed1488602a94c0d.gif'/>",
					"泪": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/1679327e411f27f4a2547d989fe982cd.gif'/>",
					"偷笑": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/c4ad86f411946e1c3212484de93ff917.gif'/>",
					"亲亲": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/0310ff823298f496eda6e7bdaabff5ed.gif'/>",
					"生病": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/931ff97c7dd2d7cbfe6daa16438101a6.gif'/>",
					"太开心": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/4217bf643e720b630bfa7392fc04c94a.gif'/>",
					"白眼": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/11e6eb949ad17c9a6c9abdc26b3cdb5a.gif'/>",
					"右哼哼": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/8b0d7edd4bb6fb060a5c998cff3d19e0.gif'/>",
					"左哼哼": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/f521f84d27e2b177df3875ee6c9cecb2.gif'/>",
					"嘘": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/046f92526c6d5ca3c0381fd5033dfd2f.gif'/>",
					"衰": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/d8a903b5d37d761a8052e554ff8bb8ac.gif'/>",
					"委屈": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/60870d59c32d212b3b7fd6be178d8eba.gif'/>",
					"吐": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/14529d0d77475573031afb7eb1277864.gif'/>",
					"哈欠": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/af7466b790e90e12d217f489af44b8c6.gif'/>",
				},
				setInterval: null,
				kfname: null, // 客服服务
				addReplayVisible: false,
				relaysuccessInfo: true,
				replayContent: '',
				rateValue: 5, // 商品评分
				// commentImgArr:[],
				goodsCommentList: [],
				specificationTypeId: '', // 该属性参加的活动类型id
				specifiStock: 0, //规格得库存
				lastStock: 0, //剩余库存
				scId: '', //规格id
				downGoods: false, //返回商品为空的时候，表示商品已下架
				serviceList: [], //服务保障
				comtactVisible: false,
				comtactruleForm: {
					comtactName: '',
					comtactPhone: '',
					comtactRemark: '',
				},
				//rules前端验证
				rules: {
					comtactName: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					comtactRemark: [{
						required: true,
						message: '请输入留言',
						trigger: 'blur'
					}],
					comtactPhone: [{
						required: true,
						trigger: ["blur", "change"],
						validator: (rule, value, callback) => {
							if (value == '') {
								callback(new Error('请输入联系电话'));
							} else if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(value)) {
								callback(new Error('请输入11位手机号'));
							} else {
								callback();
							}
						}
					}],
					codePhone: [{
						required: true,
						message: '输入短信验证码',
						trigger: 'blur'
					}],
				},
				userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
				imUserId: '' //店铺用户id
			};
		},
		// 注册组件
		components: {
			magnifier,
			hotGoods,
			shopStoreItem,
			goodsSizeItem,
			countDown,
			flipDown
		},
		computed: {
			...mapState(['getprovince', 'currentAddress'])
		},
		/**
		 * 数据发生改变
		 */
		/**
		 * 创建完毕
		 */
		created() {
			this.userid = JSON.parse(this.id).userId
			this.getGoodsCommentList()
			this.getCommoditylistDetail();
			// this.shippingAreaValue = [this.currentAddress.province,this.currentAddress.city,this.currentAddress.district]
		},
		mounted() {
			this.getCommoditylist();
			this.getGoodsAdvice();
			this.getAttributelists();
			console.log('------------1-----------1');


			window.addEventListener('scroll', this.handleScroll)
		},
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll);
			this.socket.close(); //断开websocket连接
			clearInterval(this.setInterval)
		},
		watch: {
			'$route'(to, from) { //监听路由是否变化
				if (to.query.id != from.query.id) { //判断id是否有值
					//调数据
					this.getGoodsCommentList()
					this.getCommoditylistDetail();
					this.getCommoditylist();
					this.getGoodsAdvice()
					this.getAttributelists()
				}
			}
		},
		/**
		 * 里面的方法只有被调用才会执行
		 */
		methods: {
			// 点击图片进行查看
			imglook(url){
			 let newWindow = window.open();
			 newWindow.document.write('<div style="display: flex; justify-content: center; align-items: center; height: 100vh;"><img src="' + url + '" style="max-width: 100%; max-height: 100%;" /></div>');
			},
			// 点击上传图片
			shangchuanimgfn() {
				this.$refs.files.click()
			},
			// 选中图片状态改变
			handleFileChange(event) {
				const file = event.target.files[0];
				if (file) {
					// 执行图片上传的操作
					console.log('Selected file:', file.type);
					this.uploadFileimg(file);

				}
			},
			// 发图片
			uploadFileimg(file) {
				const formData = new FormData();
				formData.append('file', file);
				// console.log(`http://192.168.0.148:8080/api/common/upload/chatFile`);
				axios.post(`${Vue.prototype.$imUrl}/api/common/upload/chatFile`, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						},
					})
					.then(res => {
						console.log('Upload successful 图片', res.data.url);
						if (res.data.url) {
							let url = {
								"url": res.data.url.toString()
							}
							this.addMessage(1, url)
						}
					})
					.catch(error => {
						console.error('Error uploading file 图片', error);
					});
			},


			// 点击上传视频
			shangchuanmp4fn() {
				this.$refs.mp4files.click()
			},
			// 选中视频状态改变
			handleFileMP4Change(event) {
				const file = event.target.files[0];
				if (file) {
					// 执行图片上传的操作
					console.log('Selected file:', file.type);
					this.uploadFileMP4(file);

				}
			},
			// 发视频
			uploadFileMP4(file) {
				const formData = new FormData();
				formData.append('file', file);
				// console.log(`http://192.168.0.148:8080/api/common/upload/chatFile`);
				axios.post(`${Vue.prototype.$imUrl}/api/common/upload/chatFile`, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						},
					})
					.then(res => {
						console.log('Upload successful 视频', res.data.url);
						if (res.data.url) {
							let url = {
								"src": res.data.url.toString()
							}
							this.addMessage(5, url)
						}
					})
					.catch(error => {
						console.error('Error uploading file 视频', error);
					});
			},


			// 文字中的表情包
			textfaceimg(face) {
				let that = this
				// var text = "这是一段包含 face[微笑]、face[大笑] 和 face[开心] 的文字";
				var replacedText = face.replace(/face\[(.*?)\]/g, function(match, p1) {
					if (that.emojiMap[p1]) {
						return that.emojiMap[p1];
					} else {
						return match;
					}
				});
				return replacedText
			},
			// 点击发送进行商品的发送,单商品咨询
			onegoodschat() {
				this.addMessage(3, JSON.stringify(this.goodspart))
				this.isshowminicard = false
				// this.goodspart = {} // 始终显示
			},
			// 点击表情包
			clickimg(e) {
				this.addMessage(4, e)
			},
			// 判断是哪一个gif
			giffn(e) {
				// console.log( `../../../static/layui/images/face/${e}`);
				return require(`../../../static/layui/images/face/${e}`)
			},
			// 点击发送信息
			addMessage(msgtype, content) {
				console.log("msgtype, content", msgtype, content);
				let fromlist = {}
				if (msgtype == 3) { // 商品 
					fromlist = {
						code: "2",
						message: {
							chatId: this.from.fromId,
							chatType: "3",
							extend: content,
							fromId: this.from.userId,
							messageType: msgtype + '', // 0文本， 1图片 2压缩包文件 3商品 4表情包 5视频
							mine: true,
							timestamp: new Date(),
							type: "0"
						}
					}
				} else if (msgtype == 1) { // 图片
					fromlist = {
						code: "2",
						message: {
							chatId: this.from.fromId,
							chatType: "3",
							extend: content,
							fromId: this.from.userId,
							messageType: msgtype + '', // 0文本， 1图片 2压缩包文件 3商品 4表情包 5视频
							mine: true,
							timestamp: new Date(),
							type: "0"
						}
					}
				} else if (msgtype == 5) { //视频
					fromlist = {
						code: "2",
						message: {
							chatId: this.from.fromId,
							chatType: "3",
							extend: content,
							fromId: this.from.userId,
							messageType: msgtype + '', // 0文本， 1图片 2压缩包文件 3商品 4表情包 5视频
							mine: true,
							timestamp: new Date(),
							type: "0"
						}
					}
				} else {
					fromlist = {
						code: "2",
						message: {
							chatId: this.from.fromId,
							chatType: "3",
							content: content,
							fromId: this.from.userId,
							messageType: msgtype + '', // 0文本， 1图片 2压缩包文件 3商品 4表情包 5视频
							mine: true,
							timestamp: new Date(),
							type: "0"
						}
					}
				}
				// console.log("发送的信息",fromlist);
				this.socket.send(JSON.stringify(fromlist));
				this.messageText = '';
				// console.log('点击发送了');
			},
			// 点击联系客服
			ToChat() {
				// this.$message('okok!');
				this.isshowminicard = true
				this.dialogVisible = true // 打开聊天框
				this.isdisplay = false // 关闭表情包窗口
				getAfterSaleschatpoople(JSON.parse(this.id).userId, JSON.parse(this.id).roleId, '3').then((res) => {
					// 后端遗留问题 : 如果a客服休息一天,甲用户和b聊,那么a 上线时会和ab来回切换聊 bug
					console.log("双方信息:", res);
					if (res.code == 500) {
						this.$message.error(res.msg);
						return
					} else {
						this.kfname = res.data.name
						this.from = {
							userId: res.data.userId,
							fromId: res.data.fromId
						}
						this.getoldmsg(res.data.userId, res.data.fromId)
					}
				})
				if (this.socket) return // 已连接不重复链接websocket
				this.socket = new WebSocket(
					`${Vue.prototype.$wsUrl}/?token=${JSON.parse(this.id).userId}`
				);
				this.socket.onopen = (e) => {
					console.log('scoket链接成功!');
					this.setInterval = setInterval(() => {
						console.log('心跳开启');
						this.socket.send(JSON.stringify({
							code: 0
						}));
					}, 10000)
					this.socket.send(JSON.stringify({
						code: 1
					}));
				};

				this.socket.onclose = (event) => {
					if (event.wasClean) {
						console.log(`scoket关闭, code=${event.code} reason=${event.reason}`);
					} else {
						// 例如服务器进程被杀死或网络中断
						// 在这种情况下，event.code 通常为 1006
					}
				};

				this.socket.onerror = (error) => {
					console.log(`scoket异常 ${error.message}`);
				};
				this.socket.onmessage = (event) => {
					console.log(`收到消息2: ${event.data}`);
					// console.log('转换完了', JSON.parse(event.data).message.content);
					// console.log("code为:", JSON.parse(event.data).code);
					if (JSON.parse(event.data).code == 0) {
						console.log("停止");
						return
					}
					if (JSON.parse(event.data).code == 4) {
						this.$message({
							message: '客服已转接!',
							type: 'success'
						});
						this.kfname = JSON.parse(event.data).message.name
						this.from.fromId = JSON.parse(event.data).message.chatId.toString() // 新客服id
						if (true) {
							this.messageText = "----聊天状态已改变,请注意查收新消息!----"
							this.addMessage(0, JSON.stringify(this.messageText))
						}
					}
					if (JSON.parse(event.data).code == 5) {
						// this.$message({
						// 	message: '客服已读!',
						// 	type: 'success'
						// });
						this.messages.forEach(item => {
							item.readState = 'true'
						})
					}
					if (JSON.parse(event.data).message.messageType == 0) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							content: JSON.parse(event.data).message.content,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("文字push成功");
					} else if (JSON.parse(event.data).message.messageType == 3) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							extend: JSON.parse(event.data).message.extend,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
					} else if (JSON.parse(event.data).message.messageType == 1) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							extend: JSON.parse(event.data).message.extend,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("图片push成功");
					} else if (JSON.parse(event.data).message.messageType == 5) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							extend: JSON.parse(event.data).message.extend,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("视频push成功");
					} else if (JSON.parse(event.data).message.messageType == 4) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							content: JSON.parse(event.data).message.content,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("表情包push成功");
					}
					this.$nextTick(() => {
						let scrollElem = document.getElementById('message-list');
						scrollElem.scrollTo({
							top: scrollElem.scrollHeight,
							behavior: 'smooth'
						});
					});
				};
				setInterval(() => {
					this.isshowminicard = false
				}, 8000)
			},
			// 获取聊天记录
			getoldmsg(u, c) {
				// console.log("进入了历史记录:",u, c);
				const page = {
					chatId: c,
					fromId: u,
					chatType: "0", // 0是单聊
					messageType: " ", // 不传为获取所以类型的历史记录
					current: "1",
					size: "40"
				}
				this.loadingdialog = true // 开启loading
				getoldmessage(page).then((res) => {
					console.log("正确的历史信息：", res.data);
					this.messages = [...res.data]
					this.$nextTick(() => {
						let msg = document.getElementById('message-list') // 获取对象
						msg.scrollTop = msg.scrollHeight // 滚动高度
					})
					this.loadingdialog = false // 关闭loading
				}).catch((req) => {
					console.log("错误信息", req);
				})
			},
			// 查询客服id
			getImUserID() {
				imUserID({
						bxmid: this.info.mid
					})
					.then((res) => {
						this.imUserId = res.data.imUserId;
					})
					.catch((err) => {
						this.$message.error("查询店铺用户失败，请稍后再试！");
					});
			},
			// 联系我们
			comtactUs() {
				this.comtactVisible = true
			},
			// 联系商家
			getCallCenter(e) {

				//以下为 layim 最新版写法
				// layui.config({
				//   layimPath: './static/dist/' //配置 layim.js 所在目录
				//   ,layimAssetsPath: './static/dist/layim-assets/' //layim 资源文件所在目录
				// }).extend({
				//   layim: layui.cache.layimPath + 'layim' //配置 layim 组件所在的路径
				// }).use('layim', function(layim){ //加载组件
				//   //先来个客服模式压压精
				//   layim.config({
				//     brief: true //是否简约模式（如果true则不显示主面板）
				//   }).chat({
				//     name: '一个新窗口'
				//     ,type: 'friend'
				//     ,avatar: 'http://tp1.sinaimg.cn/5619439268/180/40030060651/1'
				//     ,id: -2
				//   });
				// });



				console.log('客服');
				console.log(baseUrl);
				if (this.userInfo.userId == undefined) {
					this.$message.error("请登录！");
					setTimeout(() => {
						this.$router.push('/login')
					}, 2000)
					return
				}
				this.addImFriends()
				layui.use('layim', (layim) => {
					var layim = layui.layim;
					console.log(this.storeInfo.logo || "static/layui/images/0.jpg");
					//自定义会话  
					layim.config({
							brief: false, //是否简约模式（如果true则不显示主面板）
							init: {
								url: baseUrl +
									'/im/getusers' //接口地址（返回的数据格式见下文） https://www.nays.com.cn/center/im/getusers
									,
								type: 'get' //默认get，一般可不填
									,
								data: {
									userid: this.userInfo.imUserId || '',
								} //额外参数
							},

						})
						.chat({ //客服信息
							name: this.storeInfo.name,
							type: 'friend',
							avatar: this.storeInfo.logo || "static/layui/images/0.jpg",
							id: this.imUserId || ''
						});
					// layer.msg('也就是说，此人可以不在好友面板里');
				})
			},
			addImFriends() {
				imFriends({
						uid: this.userInfo.userId,
						friendid: this.imUserId,
					})
					.then((res) => {
						console.log(res);
						if (res.code == 0) {
							layui.use('layim', (layim) => {
								var layim = layui.layim;
								console.log(res);
								console.log(this.storeInfo);
								layim.addList({
									type: 'friend' //列表类型，只支持friend和group两种
										,
									avatar: this.storeInfo.logo || "static/layui/images/0.jpg" //好友头像
										,
									username: this.storeInfo.name //好友昵称
										,
									groupid: 5 //所在的分组id
										,
									id: this.imUserId //好友id
										,
									sign: "签名" //好友签名
								});
							})
						}
					})
			},
			// 服务保障
			getServiceGuarantee() {
				serviceGuarantee({
						mid: this.info.mid
					})
					.then((res) => {
						if (res.code == 0) {
							if (res.rows.length > 0) {
								this.serviceList = res.rows
							}
						}
					})
			},

			// 顶部框选择
			topNavClick(tabId, index) {
				this.isTabActive = tabId
				this.isSelectedTab = index
				this.activeName = String(index)
			},
			// 滚动
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				var offsetTop = document.querySelector('#searchBar').offsetTop
				if (scrollTop > 880) {
					this.searchBarFixed = true
				} else {
					this.searchBarFixed = false
				}
			},
			//   选择的图片 mp4 avi dat 3gp mov rmvb
			selectedImg(url, index) {
				if (url.indexOf('mp4') > 0 || url.indexOf('avi') > 0 || url.indexOf('dat') > 0 || url.indexOf('3gp') > 0 ||
					url.indexOf('mov') > 0 || url.indexOf('rmvb') > 0) {
					this.selected = true;
					this.isVedio = true
					this.isSelectedImg = index;
					this.selectedImgUrl = url
					// this.bigphotos = url
				} else {
					this.isVedio = false
					this.selected = true;
					this.isSelectedImg = index;
					this.selectedImgUrl = url
					this.bigphotos = url
				}
			},
			// 添加收藏
			addCollectionHandle(id) {
				if (this.userInfo.userId == undefined) {
					this.$message.error("请登录！");
					setTimeout(() => {
						this.$router.push('/login')
					}, 2000)
					return
				}
				// this.loading = true;
				const req = {
					type: 1, //1:商品；2：店铺；必填
					uid: this.userInfo.userId,
					cid: id, // 商品id
				}
				addCollection(req)
					.then((res) => {
						if (res.code == 0) {
							this.getCommoditylistDetail()
						}
					})
					.catch((err) => {
						this.$message.error("关注失败，请稍后再试！");
					});
			},
			// 取消收藏
			removeCollectionHandle(id) {
				// this.loading = true;
				const req = {
					type: 1, //1:商品；2：店铺；必填
					uid: this.userInfo.userId,
					cid: id, // 商品id
				}
				removeCollection(req)
					.then((res) => {
						if (res.code == 0) {
							this.getCommoditylistDetail()
						}
					})
					.catch((err) => {
						this.$message.error("关注失败，请稍后再试！");
					});
			},
			// 店铺查询
			searchStorerList(id) {
				this.loading = true;
				storerList({
						// userId:this.userInfo.userId||'',
						bxmId: id,
					})
					.then((res) => {
						this.loading = false;
						this.storeInfo = res.rows[0];
						console.log(res.rows[0]);
					})
					.catch((err) => {
						this.editFormVisible = false;
						this.loading = false;
						this.$message.error("店铺查询失败，请稍后再试！");
					});
			},

			// 店铺评价查询
			getScore(id) {
				score({
						type: 1,
						bxmId: id,
					})
					.then((res) => {
						if (res.code == 0) {
							this.storeScore = res.data;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.$message.error(res.msg);
					});
			},

			// 填写地址选择
			areaHandleChange(value) {
				this.$refs['cascaderAddr'].getCheckedNodes()
				// this.ruleForm.areaid = value[value.length-1]
				// console.log(this.cascaderAreaValue,this.ruleForm.areaid,'填写地址选择');
			},

			// 获取商品规格
			getAttributelists() {
				getAttributelist({
						productId: this.$route.query.id
					})
					.then(res => {
						console.log('获取商品规格55',res);
						if (res.code == 0 && res.rows) {
							for (var i = 0; i < res.rows.length; i++) {
								if (res.rows[i].bxyname) {
									this.attributelist.push(res.rows[i])
								}
							}

						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.$message.error('查询商品属性失败，请稍后再试!')
					})
			},
			// 商品详情查询
			getCommoditylistDetail() {
				this.loading = true;
				commodityDetails({
						id: this.$route.query.id,
						stype: '',
						userId: this.userInfo.userId || ''
					})
					.then((res) => {
						if (res.code == 0) {
							this.loading = false;
							console.log("商品详情", res);
							if (res.rows.length > 0) {
								this.info = res.rows[0];
								this.activityTypeNum = res.rows[0].bxyMarketing ? res.rows[0].bxyMarketing
									.activityTypeId : '',
									this.moreImgArr = res.rows[0].more_photos != null && res.rows[0].more_photos !=
									'' ? res.rows[0].more_photos.split(',') : [];
								this.bigphotos = this.moreImgArr[0] != null ? this.moreImgArr[0] : '';
								this.stock = res.rows[0].stock
								if (res.rows[0].video == "" || res.rows[0].video == null) {
									this.isVedio = false
								} else {
									this.moreImgArr.unshift(res.rows[0].video)
								}
								this.specifiStock = res.rows[0].commodityNum ? res.rows[0].commodityNum : res.rows[0]
									.stock;
								this.lastStock = res.rows[0].stock;
								this.videoUrl = res.rows[0].video;
								this.searchStorerList(this.info.mid)
								this.getScore(this.info.mid)
								this.getImUserID();
							} else {
								this.downGoods = true
							}
						}
					})
					.catch((err) => {
						this.editFormVisible = false;
						this.loading = false;
						this.$message.error("查询商品列表失败，请稍后再试！");
					});
			},
			// 选规格价格发生变化
			async getgoodsSize(ids) {
				console.log('---------规格变化');
				this.info.number = 1
				this.idArr = []
				ids.forEach((item) => {
					this.idArr.push(item.id)
				})
				let obj = {}
				obj.productId = this.$route.query.id;
				obj.specificationIds = this.idArr.toString();
				if (this.userInfo.userId) {
					obj.uid = this.userInfo.userId;
				}
				await getSpecificationDetail(obj)
					.then(res => {
						console.log("asxdcfvgbhnmsdfvgbh",res);
						this.goodspart = {
							"id": res.rows[0].goodsId,
							"image": res.rows[0].image,
							"goodsname": res.rows[0].goodsname,
							"price": res.rows[0].price,
						}
						console.log("商品小卡片详情:", this.goodspart);
						if (res.code == 0) {
							if (res.rows.length > 0) {
								this.specificationlist = res.rows.length > 0 ? res.rows : [];
								this.specificationActivityTypeId = res.rows[0].bxyMarketing ? res.rows[0]
									.bxyMarketing.activityTypeId : ''
								this.activityTypeNum = res.rows[0].bxyMarketing ? res.rows[0].bxyMarketing
									.activityTypeId : ''
								this.scId = res.rows[0].id;
								this.info.realprice = res.rows.length > 0 ? (res.rows[0].price || 0) : (this.info
									.realprice || 0);
								this.needPoints = res.rows.length > 0 ? (res.rows[0].needPoints || 0) : 0;
								this.info.marketprice = res.rows.length > 0 ? (res.rows[0].marketprice || 0) : (
									this.info.marketprice || 0);
								this.selectAttrId = res.rows.length > 0 ? (res.rows[0].id || '') : '';
								this.specificationTypeId = res.rows.length > 0 ? (res.rows[0].activityTypeId) : '';
								this.specifiStock = res.rows[0].commodityNum ? res.rows[0].commodityNum : res.rows[
									0].stock;
								this.lastStock = res.rows[0].stock;
								// this.specifiStock = res.rows.length > 0 ? res.rows[0].stock : this.info.stock;
								this.bigphotos = res.rows[0].image ? res.rows[0].image : this.info.photos;
							}
						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						console.log('选规格价格发生变化发生错误',err);
						// this.$message.error('查询商品属性失败，请稍后再试！')
					})

			},
			// 获取购物车
			getshoppingCartlist() {
				shoppingCartlist({
						uid: this.userInfo.userId || ''
					})
					.then(res => {
						if (res.length > 0) {
							this.$store.commit('getCartList', res)
						}
					})
					.catch(err => {
						this.$message.error('购物车查询失败，请稍后再试！')
					})
			},
			// 加入购物车
			onAddCar(id, number, bXySid, status, approvalStatus) {
				if (this.specifiStock > 0) {
					if (this.userInfo.loginName == null || this.userInfo.loginName == "") {
						this.$router.push('/login')
						return
					}
					if (status == 1 && approvalStatus == 1) {
						if (this.attributelist.length > 0) {
							if (this.selectAttrId == '') {
								this.$message({
									type: 'info',
									message: '请选择规格'
								})
								return
							}
						} else {
							this.selectAttrId = 0
						}
						addShoppingCart({
								cid: id,
								uid: this.userInfo.userId,
								number: number,
								bxysid: this.selectAttrId
							})
							.then((res) => {
								console.log(res)
								if (res.code == 0) {
									this.addDialogVisible = true;
									this.getshoppingCartlist()
									return
								}
							})
							.catch((err) => {
								this.loading = false;
								this.$message.error("添加购物车失败，请稍后再试！");
							});
					} else {
						this.$message.error('暂时缺货')
						return
					}
				} else {
					this.$message({
						type: 'error',
						message: '商品库存不足,请联系卖家！'
					})
				}
			},
			// 热卖商品列表查询
			getCommoditylist(id) {
				var userId = '';
				this.loading = true;
				if (this.userInfo.userId) {
					userId = this.userInfo.userId
				}



				// commoditylist({
				//   cid:id||'',
				//   pageSize: 10,
				//   pageNum: 1
				// })
				//   .then((res) => {
				//    console.log('00002');
				//   })
				//   .catch((err) => {
				//    console.log('00001');
				//   });


				// 111

				let obj = {}
				obj.cid = id || '';
				obj.pageSize = 10;
				obj.pageNum = 1;
				if (this.userInfo.userId) {
					obj.uid = this.userInfo.userId;
				}
				commoditylist(obj)
					.then(res => {
						this.loading = false;
						if (res.code == 0) {
							this.lefthotGoodsList = res.rows.length > 8 ? res.rows.slice(0, 8) : res.rows;
						}
					})
					.catch((err) => {
						this.editFormVisible = false;
						this.loading = false;
						this.$message.error("查询推荐商品列表失败，请稍后再试！");
					});
			},

			// 计数量
			handleChange(value) {
				console.log(value);
				// this.info.marketprice = value*this.info.marketprice;

			},

			// 立即下单
			orderNow(status, approvalStatus) {
				console.log(status);
				console.log(approvalStatus);
				if (this.specifiStock > 0) {
					if (status == 1 && approvalStatus == 1) {
						let selectList = [];
						let goodList = [];
						this.info.specificationlist = this.specificationlist
						this.info.needPoints = this.needPoints
						goodList.push({
							...this.info
						})
						let obj = {
							name: this.info.name,
							selectAttrId: this.selectAttrId,
							bxmId: this.info.mid,
							goods: goodList
						}
						selectList.push(obj)
						console.log("带有红包字段的数据", selectList);
						sessionStorage.setItem("selectList", JSON.stringify(selectList));
						console.log(this.scId);
						console.log(selectList);
						this.$router.push(`/orderDetail?buyNow=true&scId=${this.scId}`)
					} else {
						this.$message.error('暂时缺货')
						return
					}
				} else {
					this.$message({
						type: 'error',
						message: '商品库存不足,请联系卖家！'
					})
				}

			},


			// ====================== 商品面议时，联系我们 开始======================================
			//   关闭弹框清空
			beforeClose() {
				this.comtactVisible = false
				this.comtactruleForm = {
					comtactName: '',
					comtactPhone: '',
					comtactRemark: '',
				}
			},

			submitForm() {
				this.$refs.comtactruleForm.validate(valid => {
					if (valid) {
						userFeedback({
								name: this.comtactruleForm.comtactName,
								phone: this.comtactruleForm.comtactPhone,
								content: this.comtactruleForm.comtactRemark,
								mid: this.info.mid
							})
							.then((res) => {
								if (res.code == 0) {
									this.comtactVisible = false
									this.comtactruleForm = {
											comtactName: '',
											comtactPhone: '',
											comtactRemark: '',
										},
										this.$message({
											type: 'success',
											message: '提交成功'
										});
								} else {
									this.$message.error(res.msg);
								}
							})
					}
				})
			},
			// ====================== 商品面议时，联系我们 结束======================================


			// -------------- 放大镜开始  -------------------------//
			// bigImgMove(){
			//     var mask = $('#mask');
			//     var bigBox = $('#bigbox');
			//     var bigImg = bigBox.children[0];
			// },
			// -------------- 放大镜结束  -------------------------//

			// -------------- 切换tab 开始  -------------------------//
			//   切换tab
			tabhandleClick(tab, event) {
				this.isSelectedTab = this.activeName
				if (this.activeName == 4) {
					this.getServiceGuarantee()
				}
			},
			// -------------- 切换tab 结束 -------------------------//

			// -------------- 商品评价 开始 -------------------------//
			// 获取头像失败
			errorHandler() {
				return true
			},
			//  个人信息加密
			encryption(str, len) {
				if (str != null) {
					if (str.length <= len) {
						return str;
					} else {
						var newStr = str.substring(0, 1);
						var newStrs = str.substring(str.length, str.length - 2);
						newStr = newStr + "****" + newStrs;
						return newStr;
					}
				}
			},
			// 获取评价列表
			getGoodsCommentList() {
				commentList({
						goodId: this.$route.query.id,
						type: 2, //1.店铺评级，2.商品评价
					})
					.then((res) => {
						if (res.code == 0) {
							this.goodsCommentList = res.rows
							this.commentLength = this.goodsCommentList.length
							this.goodsCommentList.forEach((item) => {
								item.matchScore = Number(item.matchScore)
								// this.rateValue = ((Number(item.matchScore) + Number(item.serviceScore) + Number(item.speedScore))/3) || 0
								item.isLike = false
								if (item.images) {
									item.images = item.images.split(',')
									item.images.forEach((imageItem, index) => {
										item.images[index] = `${imageItem}`

									});
								} else {
									item.images = []
								}

							})
						}
					})
					.catch((err) => {
						this.$message.error("查询商品评价失败，请稍后再试！");
					});
			},

			// 点赞
			likeHadle(id) {

				this.goodsCommentList.forEach((item) => {
					if (item.bXyDoeid == id && item.isLike == false) {
						item.likepoint = item.likepoint + 1
						item.isLike = !item.isLike
					} else if (item.bXyDoeid == id && item.isLike == true) {
						item.likepoint = item.likepoint == 0 ? 0 : item.likepoint - 1
						item.isLike = !item.isLike
					}
				})
			},
			openReplayHadle(id) {
				this.goodsCommentList.forEach((item) => {
					if (item.bXyDoeid == id) {
						item.showRepalyBox = !item.showRepalyBox
					}
				})
			},
			// 回复
			replayHandle(id) {
				if (this.userInfo.userId == undefined) {
					this.$message.error("请登录！");
					setTimeout(() => {
						this.$router.push('/login')
					}, 2000)
					return
				}
				if (JSON.stringify(this.userInfo) == "{}") {
					this.relaysuccessInfo = false
				}
				if (this.replayContent != '') {
					replayComment({
							bXyDoeid: id,
							uid: this.userInfo.userId,
							content: this.replayContent
						})
						.then((res) => {
							if (res.code == 0) {
								this.getGoodsCommentList()
								this.replayContent = ''
								// this.addReplayVisible = true 后续若要审核，将这个弹框打开
							}
						})
						.catch((err) => {
							this.$message.error("回复评论失败，请稍后再试！");
						});
				} else {
					this.$message.error("请输入回复楼主内容");
				}
			},
			// -------------- 商品评价 开始 -------------------------//

			// -------------- 商品咨询 开始 -------------------------//
			getGoodsAdvice() {
				goodsAdvice({
						goodsId: this.$route.query.id || '',
					})
					.then((res) => {
						if (res.code == 0) {
							this.goodsAdviceList = res.rows
							this.adviceLength = this.goodsAdviceList.length
						}
					})
					.catch((err) => {
						this.$message.error("查询商品列表失败，请稍后再试！");
					});
			},

			// 提问
			advisoryHandle() {
				if (this.userInfo.userId == undefined) {
					this.$message.error("请登录！");
					setTimeout(() => {
						this.$router.push('/login')
					}, 2000)
					return
				}
				if (this.inputContent == '') {
					this.$message({
						type: 'info',
						message: '请输入提问内容'
					})
					return
				}
				addgoodsAdvice({
						goodsId: this.$route.query.id || '',
						content: this.inputContent,
						uid: this.userInfo.userId
					})
					.then((res) => {
						if (res.code == 0) {
							this.getGoodsAdvice()
							this.inputContent = ''
							this.centerDialogVisible = true;
						}
					})
					.catch((err) => {
						this.$message.error("查询商品列表失败，请稍后再试！");
					});

			},
			// -------------------- 商品咨询 结束 ----------------------------------//
		},
	};
</script>

<style lang="less" scoped>
	.breakcrumbHeader {
		margin: 15px 0;
	}

	// 顶部导航栏
	.pro-fixed_none {
		display: none;
		opacity: 0;

	}

	.playBg {
		background: #958181;

		i.el-icon-video-play {
			color: #ddd;
		}
	}

	.pro-fixed-div {
		opacity: 100;
		transition: all 2s linear;
		padding: 0 332px;
		position: fixed;
		width: 100%;
		border-bottom: 1px solid #ccc;
		left: 0;
		top: 0;
		background: #f7f8f8;
		height: 40px;
		z-index: 90;
		-webkit-box-shadow: rgba(0, 0, 0, .2) 0 1px 5px 0;
		-moz-box-shadow: rgba(0, 0, 0, .2) 0 1px 5px 0;
		box-shadow: rgba(0, 0, 0, .2) 0 1px 5px 0;

		// .el-col-3{
		//   width: 10.5% !important;
		.topNav_shopName {
			height: 40px;
			width: 190px;
			padding: 10px;
			background: #DDD;
			box-sizing: border-box;
		}

		// }
		.toNav_goodsInfo {
			display: flex;
			background: #dddddd;
			height: 40px;

			.activeTab {
				color: white !important;
				background-color: #e4393c;
				border-right-color: #e4393c;
				border-left-color: #e4393c;
			}

			li.toNav_goodsInfoItem {
				padding: 0 20px;
				height: 40px;
				-webkit-box-sizing: border-box;
				box-sizing: border-box;
				line-height: 40px;
				display: inline-block;
				list-style: none;
				font-size: 14px;
				font-weight: 500;
				color: #303133;
				position: relative;
				cursor: pointer;
			}
		}
	}

	.bg-purple {
		background: #d3dce6;
	}

	.bg-purple-light {
		background: #e5e9f2;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}

	span.dettitle {
		color: #d33a31;
		line-height: 20px;
		font-weight: bold;
	}

	.tagadWord {
		font-size: 14px;
		color: #e30101;
		margin-bottom: 10px;
	}

	.tag {
		font-size: 14px;
		color: #d13030;
		margin-bottom: 10px;
		display: inline-block;
		border: 1px solid #d13030;
		border-radius: 4px;
		padding: 0 3px;
	}

	img#smallBox_img {
		width: 440px;
		height: 440px;
	}

	.zhekouCss {
		color: #d33a31;
		border: 1px solid #d33a31;
		padding: 3px 6px;
		border-radius: 4px;
		margin-right: 18px;
		font-size: 12px;
		box-sizing: border-box;
	}

	//   规格按钮
	.second-detail {
		/deep/.el-radio.is-bordered.is-checked {
			border-color: #d33a31;
		}

		/deep/.el-radio__input.is-checked+.el-radio__label {
			color: #d33a31;
		}

		/deep/.el-radio__input.is-checked .el-radio__inner {
			border-color: #d33a31;
			background: #d33a31;
		}
	}

	.twoButtom.el-row {
		margin-bottom: 20px;

		/deep/i.el-icon-star-on {
			font-size: 18px;
			color: #f12b2d;
			vertical-align: text-bottom;
		}

		/deep/i.el-icon-star-off {
			font-size: 18px;
			vertical-align: text-bottom;
		}
	}

	/* 商品Tabs项 */
	.goodsTabs {
		font-size: 14px;
	}

	.goodsTabsr_card {
		/deep/.el-tabs__item {
			color: #555555;
		}

		/deep/.el-tabs__item.is-top.is-active {
			color: white !important;
			background-color: #e4393c !important;
			border-right-color: #e4393c !important;
			border-left-color: #e4393c !important;
		}

		/deep/.el-tabs__header {
			background-color: #ddd;
			border-bottom: 2px solid #e4393c;

		}

		/deep/.el-tabs__content {
			min-height: 500px;
			background: #f8f8f8;
		}
	}

	/** 商品详情 */
	.goodsDetails {
		/deep/img {
			width: 100% !important;
		}

	}

	.kuanshi-two.fl.kuanshi-two2 span {
		// text-decoration: line-through !important;
	}

	/deep/.vue-countdown-component .time-box,
	/deep/.vue-countdown-component .time-box>div.back.anime,
	// /deep/.vue-countdown-component .time-box>div.back,
	/deep/.vue-countdown-component .time-box>div.face,
	/deep/.vue-countdown-component .time-box>div.base .base-b {
		background-color: #d33a31 !important;
	}

	/** 商品评论 */
	.goodsCommentList {
		padding: 15px;
		border-bottom: 1px solid #cccccc;

		.commentListImg {
			width: 60px;
			height: 60px;
			border: 1px solid #ccc;
			padding: 0px;
			margin: 10px;
		}

		/deep/span.el-rate__item {
			color: #e4393c !important;
		}

		/deep/span.el-avatar.el-avatar--circle {
			width: 40px !important;
			height: 40px !important;
			line-height: 40px !important;
			vertical-align: middle;
			margin-right: 10px;
		}

		/deep/.el-avatar>img {
			display: inline !important;
		}

		.goodsCommentList_content {
			font-size: 14px;
			margin-top: 10px;
		}

		.lastLine {
			display: flex;
			justify-content: space-between;

			.goodsCommentList_goodsName {
				color: #999;

				.goodsNameText {
					width: 260px;
					display: inline-block;
					vertical-align: top;
					margin-bottom: 10px;
				}
			}

			.goodsCommentList_opreate {
				span {
					color: #ccc;

					img {
						width: 25px;
						cursor: pointer;
					}
				}

				i.el-icon-chat-dot-round {
					font-size: 22px;
					vertical-align: sub;
					color: #ccc;
					margin-left: 15px;
					cursor: pointer;
				}
			}
		}

		.repalyBox {
			text-align: right;
			margin-top: 4px;
		}

		.redColor {
			color: #b30c0c
		}
	}


	/* 商品咨询 */
	.goods_advisory {
		// text-align: center;
		font-size: 18px;
		// margin-top: 100px;
	}

	.goods_advisory h1 {
		margin-top: 20px;
	}

	.goods_advisory h2 {
		margin-top: 20px;
	}

	.goods_advisory h3 {
		margin-top: 20px;
	}

	.goods_advisory_input {
		width: 50%;
		-webkit-appearance: none;
		background-color: #FFF;
		background-image: none;
		// border-radius: 4px;
		border: 1px solid #DCDFE6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: inherit;
		height: 41px;
		line-height: 41px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		margin-right: -5px;
	}

	.goods_advisory_input_1 {
		width: 80%;
		-webkit-appearance: none;
		background-image: none;
		// border-radius: 4px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		font-size: inherit;
		height: 41px;
		// line-height: 40px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		margin-right: -5px;
	}

	.advisory_button {
		background: #e4393c !important;
		border: 1px solid #e4393c !important;
		color: white !important;
		border-radius: 0;
	}

	.goods_adviceList {
		margin-top: 20px;

		span.textRight {
			margin-right: 15px;
			font-size: 14px;
			color: #333;
			font-weight: 700;
		}

		.askText {
			width: 20px;
			height: 20px;
			border-radius: 10px;
			font-size: 14px;
			color: #fff !important;
			text-align: center;
			/* float: left; */
			display: inline-block;
			background: #d13030;
		}

		.replayText {
			background: #00833d;
		}

		.goods_adviceList_right {
			text-align: right;

			span.textRight {
				color: #999;
				font-size: 14px;
			}
		}
	}

	/* 提问狂 */
	.dialog-footer {
		margin-top: 20px;
		display: block;
	}

	.addGoodsInfo {
		font-size: 24px;
	}

	.addCartBox .el-button--primary {
		color: #fff;
		background-color: #ff6700;
		border-color: #e65d00;
	}

	.cascaderArea.el-cascader {

		/deep/input[disabled],
		/deep/input[disabled="disabled"],
		/deep/input[readonly],
		/deep/input[readonly="readonly"] {
			background-color: white;
		}
	}

	// 虚拟商品
	.virtualType {
		font-size: 12px;
		font-weight: 400;
		background-color: #ff5b3d;
		color: #fff;
		padding: 4px;
		margin-right: 2px;
		-webkit-border-radius: 5px;
		border-radius: 5px;
	}

	// 服务保障
	.serviceGuarantee {
		padding: 40px;
		box-sizing: border-box;

		.bigImgSizeCss.el-image {
			width: 60px;
			height: 60px;
			background: #f5f5f5;
			cursor: pointer;
			position: relative;

			/deep/.image-slot {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}

		.serveTitlebox {
			border-bottom: 1px solid #e5e5e5;
			padding-bottom: 20px;
			margin-bottom: 20px;

			.serveTitle {
				display: block;
				line-height: 32px;
				font-size: 14px;
				font-weight: bolder;
				color: #000;
			}

			.decorDetail {
				display: block;
				line-height: 21px;
				font-size: 12px;
				color: #666;
			}
		}

	}

	.purchaseRow {
		height: 90px;
	}

	.comtactUs {
		margin-top: 50px;
	}

	.serviceBn {
		margin-top: 20px;

	}

	.serviceBn .el-button {
		background: #fff;
		border: 1px solid #dcdfe6;
		color: #606266;
	}

	.dialogContent {
		height: 500px;
	}

	/deep/.el-dialog__body {
		padding: 10px 5px !important;
		color: #606266;
		font-size: 14px;
		word-break: break-all;
	}

	.chat-box {
		display: flex;
		flex-direction: column;
		height: 100%;
		width: 100%;
		margin: 0 auto;
		border: 0px;
	}

	#message-list {
		flex: 1;
		overflow-y: auto;
	}

	.leftmessage {
		display: flex;
		flex-direction: column;
		margin: 4px 0;
		width: 100%;
		min-height: 50px;
		font-size: 14px;
		position: relative;

		.divtext {
			padding: 0 50px;
		}

		.divimg {
			height: 30px;
			padding: 0 15px;

			img {
				width: 30px;
				height: 30px;
			}
		}

		.divzt {
			position: absolute;
			color: #ccc;
			top: -5px;
			left: 50px;
		}


	}

	.rightmessage {
		display: flex;
		flex-direction: column;
		position: relative;
		margin: 4px 0;
		width: 100%;
		font-size: 14px;

		.divtext {
			padding: 0 50px;
			display: flex;
			justify-content: end;


			.minicard {
				padding-bottom: 15px;
				width: 250px;
				height: 110px;
				background-color: #f1f1f1;
				border-radius: 8px;
				padding: 5px;
				display: flex;

				.left {
					flex: 1.5;
					background-color: #c4ffee;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.right {
					flex: 2;
					position: relative;

					.dianjifs {
						line-height: 30px;
						text-align: center;
						color: #dcdfe6;
						width: 85px;
						height: 30px;
						border-radius: 20px;
						background-color: #D33A31;
						transform: translateX(-50%);
						cursor: pointer;
					}

					span {
						font-size: 14px;
						transform: scale(0.8);
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
					}
				}


			}
		}

		.divimg {
			height: 30px;
			padding: 0 15px;
			display: flex;
			justify-content: end;

			img {
				width: 30px;
				height: 30px;
			}
		}

		.divzt {
			position: absolute;
			color: #ccc;
			top: -5px;
			right: 50px;
		}
	}

	.message-text {
		font-size: 14px;
	}

	.input-box {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 10px;
		border-top: 1px solid #ccc;
		position: relative;

		.imgbox {
			background-color: #eeeeee;
			width: 202px;
			height: 145px;
			position: absolute;
			top: -155px;
			left: 10px;
			border-radius: 5px;
			padding: 5px;
			box-sizing: border-box;
			overflow-y: auto;

			&::-webkit-scrollbar {
				display: none;
			}

			img {
				cursor: pointer;
				margin: 6px 5px;
			}
		}

		.minicard {
			width: 250px;
			height: 110px;
			background-color: #e7e7e7;
			border-radius: 8px;
			padding: 5px;
			position: absolute;
			top: -130px;
			right: 10px;
			display: flex;

			.left {
				flex: 1.5;
				background-color: #c4ffee;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.right {
				flex: 2;
				position: relative;

				.dianjifs {
					line-height: 30px;
					text-align: center;
					color: #dcdfe6;
					width: 85px;
					height: 30px;
					border-radius: 20px;
					background-color: #D33A31;
					position: absolute;
					bottom: 5px;
					left: 50%;
					transform: translateX(-50%);
					cursor: pointer;
				}

				span {
					font-size: 14px;
					transform: scale(0.8);
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
				}
			}

		}

		.textimgdiv {
			width: 100px;
			height: 30px;
			background-color: #ffffff;
			position: absolute;
			top: 0px;
			left: 0;
			display: flex;
			// justify-content: space-around;
			justify-content: start;
			line-height: 25px;
			text-align: center;

			div {
				width: 40px;

				img {
					width: 20px;
					height: 20px;
					cursor: pointer;
				}
			}
		}
	}

	.input-box input {
		flex: 1;
		margin-right: 10px;
		padding: 25px 10px 0 10px;
		font-size: 14px;
		border-radius: 5px;
		border: none;
		outline: none;
	}

	.input-box button {
		padding: 6px 20px;
		font-size: 14px;
		font-weight: bold;
		border-radius: 5px;
		background-color: #d33a31;
		color: #fff;
		border: none;
		cursor: pointer;
		transition: background-color 0.3s;
	}

	.input-box button:hover {
		background-color: #d33a31;
	}
</style>


// WEBPACK FOOTER //
// src/views/goodsList/goodsDetail.vue